async function http<T>(
    path: string,
    config: RequestInit,
    method: string,
    bearerToken: string,
    crsfToken: string
): Promise<T> {
    const creds: RequestCredentials = "include";
    const requestOptionsBody = {
        method,
        body: config.body,
        credentials: creds,
        headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": crsfToken
        }
    };
    const requestOptionsBodyAuth = {
        method,
        body: config.body,
        credentials: creds,
        headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": crsfToken,
            Authorization: "Bearer " + bearerToken
        }
    };
    const requestOptionsAuth = {
        method,
        credentials: creds,
        headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": crsfToken,
            Authorization: "Bearer " + bearerToken
        }
    };
    let requestOptions = {
        method,
        credentials: creds,
        headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": crsfToken
        }
    };

    if (config?.body) {
        if (path.includes("login") || path.includes("logdetailed")) {
            requestOptions = requestOptionsBody;
        } else {
            requestOptions = requestOptionsBodyAuth;
        }
    } else {
        if (path.includes("login")) {
            requestOptions = requestOptions;
        } else {
            requestOptions = requestOptionsAuth;
        }
    }

    const response = await fetch(path, requestOptions);
    if (!response.ok) {
        console.log(`fetch failed with ${response.status} code and text ${response.statusText}`);
        throw new Error(`Status: ${response.status}, Message: ${response.statusText}`);
    }

    // may error if there is no body, return empty array
    return response.json().catch(() => ({}));
}

async function get<T>(
    path: string,
    bearerToken: string,
    crsfToken: string,
    cpContext?: ICPHeaderContext,
    config?: RequestInit
): Promise<T> {
    const init = { method: "get", ...config };
    if (cpContext?.isMaint && cpContext?.isCustomer) {
        throw new Error(`Status: 503, Message: `);
    }
    return await http<T>(path, init, "get", bearerToken, crsfToken);
}

async function post<T, U>(
    path: string,
    bearerToken: string,
    crsfToken: string,
    body: T,
    cpContext?: ICPHeaderContext,
    config?: RequestInit
): Promise<U> {
    const init = { method: "post", body: JSON.stringify(body), ...config };
    if (cpContext?.isMaint && cpContext?.isCustomer) {
        throw new Error(`Status: 503, Message: `);
    }
    return await http<U>(path, init, "post", bearerToken, crsfToken);
}

async function put<T>(
    path: string,
    bearerToken: string,
    crsfToken: string,
    body?: T,
    cpContext?: ICPHeaderContext,
    config?: RequestInit
): Promise<T> {
    const init = { method: "put", body: JSON.stringify(body), ...config };
    if (cpContext?.isMaint && cpContext?.isCustomer) {
        throw new Error(`Status: 503, Message: `);
    }
    return await http<T>(path, init, "put", bearerToken, crsfToken);
}

export { get, post, put };
